/**
 * @generated SignedSource<<3eeda68ee23ad99c8733e1e1417d0601>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionFollowupColumn_routine$data = {
  readonly activeSections: ReadonlyArray<{
    readonly assignedTeam: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly id: string;
    readonly lastVersion: {
      readonly id: string;
      readonly tasks: ReadonlyArray<{
        readonly __typename: string;
        readonly id: string;
        readonly title: string;
      }>;
      readonly title: string | null;
    };
  }>;
  readonly " $fragmentType": "RoutineOccasionFollowupColumn_routine";
};
export type RoutineOccasionFollowupColumn_routine$key = {
  readonly " $data"?: RoutineOccasionFollowupColumn_routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionFollowupColumn_routine">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "endAt"
    },
    {
      "kind": "RootArgument",
      "name": "startAt"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionFollowupColumn_routine",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "endAt",
          "variableName": "endAt"
        },
        {
          "kind": "Variable",
          "name": "startAt",
          "variableName": "startAt"
        }
      ],
      "concreteType": "RoutineSection",
      "kind": "LinkedField",
      "name": "activeSections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeam",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSectionVersion",
          "kind": "LinkedField",
          "name": "lastVersion",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "tasks",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                },
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "80469d473575f905aa10e44c51d8947c";

export default node;
